/*
THIS COMPONENT IS INCLUDED IN FORM-EDIT PRODUCT PAGE
 -----------------------------------------*/
let CollectionsSearch = {
    init: function () {

        $('#search-filter').on('keyup', function (e) {
            console.log('working...');
            e.preventDefault();
            e.stopPropagation();

            let listId = '#' + $(this).data('list');console.log(listId);
            let regular = new RegExp('.*(' + $(this).val()+')+.*', 'i');
            $(listId + ' li').hide();
            $(listId + ' li').filter(function () {
                return regular.test($(this).text().replace(/[^\wа-яё]+/gi, ""));
            }).show();

            return false;
        });

        $('.search-filter').on('keyup', function (e) {
            e.preventDefault();
            e.stopPropagation();

            let listClass = '.' + $(this).data('list');
            let regular = new RegExp('.*(' + $(this).val()+')+.*', 'i');
            let parent = $(this).parent();
            parent.find(listClass + ' li').hide();
            parent.find(listClass + ' li').filter(function () {
                return regular.test($(this).text().replace(/[^\wа-яё]+/gi, ""));
            }).show();

            return false;
        });
    }
};

export default CollectionsSearch;





